var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "2a685cea4ceaf01bc4775902cd5612c278f74486"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-site@roadie"] = {
  id: "2a685cea4ceaf01bc4775902cd5612c278f74486"
};